<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		AdvancedCard,
		ControlsContainer,
		Label,
		LabelList,
		Speedometer,
		Text,
	} from '@Shelly/shelly-design-system';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: buttonAction = statuses.find((i) => i?.hasAction);
	$: flowRate = statuses.find((i) => i?.role == 'flow_rate');
	$: labels = statuses.filter((i) => !i?.hideLabel && !i?.hasAction && i?.role != 'flow_rate');
</script>

{#each labels as status}
	{#if !status.hideLabel && !status.hasAction && status.role != 'flow_rate'}
		<AdvancedCard title={translateTemplateTitle(status.name)} class="mt-s">
			<LabelList
				size="m"
				labelList={status.labelList || []}
				slot="main"
				data-prevent-drawer-swipe
				data-prevent-sidepanel-swipe
			/>
			<div slot="right">
				<Label
					style="max-width: 100%;"
					size="l"
					value={translateTemplateTitle(status.label || status.value)}
					icon={status.icon}
				/>
			</div>
		</AdvancedCard>
	{/if}
{/each}
<div class="flex-full-height justify-content-end neo-valve-gauge">
	{#if flowRate}
		<Speedometer
			class="mb-l mt-l"
			type="primary"
			icon={flowRate.icon}
			value={flowRate.rawValue}
			valuePrefix={flowRate.unit}
			min={flowRate.min}
			max={flowRate.max}
		/>
	{/if}
	{#if buttonAction}
		<ControlsContainer class="mt-s">
			<svelte:fragment slot="first">
				<VirtualBooleanButton
					isWide
					{device}
					componentID={buttonAction.id}
					value={buttonAction.event}
					icon={buttonAction.icon}
				/>
				<Text styleType="controls-large" class="mt-s text-bold"
					>{buttonAction.event
						? $format('option_command_close', { default: 'Close' })
						: $format('option_command_open', { default: 'Open' })}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
</div>

<style>
	:global(.neo-valve-gauge .speedometer-text-styles) {
		font-size: 26px;
	}
</style>
